/**
 * Created by Ning Jiang on 3/3/2018.
 */

import {ISymbolStateConfig} from "@nolimitcity/slot-game/bin/core/reelsymbol/StateReelSymbol";
import {SymbolStack} from "@nolimitcity/slot-game/bin/core/reelsymbol/SymbolStack";
import {TimelineSprite} from "@nolimitcity/slot-game/bin/core/animation/TimelineSprite";
import {TweenLite} from "gsap";
import {WildNudgeReelSymbol} from "./WildNudgeReelSymbol";

declare module "@nolimitcity/slot-game/bin/core/reelsymbol/SymbolStack" {
    interface SymbolStack {
        noMoreFire:boolean;
        isPlayingFire:boolean;
    }
}

export abstract class BurningReelSymbol extends WildNudgeReelSymbol {

    protected _fireOverlay:TimelineSprite;

    constructor(symName:string, reelId:number, state?:ISymbolStateConfig) {
        super(symName, reelId, state);
    }

    public setVisibility(value:boolean):void {
        if(this.visible === value) {
            return;
        }
        // Logger.logDev(`setVisibility symName = ${this.symName}, visible = ${value}`);
        super.setVisibility(value);

        if(this.visible && this.stack && this.stack.isPlayingFire) {
            this.playFireOverlay(false);
        } else {
            this.stopFireOverlay(0, false, false);
        }
    }

    protected initState(stateConfig:ISymbolStateConfig):boolean {
        if(super.initState(stateConfig)) {
            // To move the patches always on the top.
            if(this._fireOverlay) {
                this.addChild(this._fireOverlay);
            }

            return true;
        }

        return false;
    }

    protected reset(remove:boolean):void {
        this.stopFireOverlay(0, false, false);
        super.reset(remove);
    }

    public playFireOverlay(playSound:boolean = true):void {
        if(!this.stack || this.stack!.noMoreFire) {
            return;
        }
        this.stack.isPlayingFire = true;

        if(!this.visible) {
            return;
        }

        // Logger.logDev(`playing fire on symbol ${this.symName}`);

        if(!this._fireOverlay) {
            this._fireOverlay = this.createFireOverlay();
        }
        // To move the patches always on the top.
        this.addChild(this._fireOverlay);
        this._fireOverlay.show();
        this._fireOverlay.playLoop();
        // move the current reel to the top of all reels.
        const reelView:PIXI.DisplayObject = this.parent;
        if(reelView) {
            reelView.parent.addChild(reelView);
        }
        if(playSound && this.playFireSound) {
            this.playFireSound();
        }
    }

    public stopFireOverlay(duration:number, setStack:boolean, noMoreFire:boolean):TweenLite | null {
        if(setStack && this.stack) {
            this.stack.isPlayingFire = false;
            this.stack.noMoreFire = noMoreFire;
        }

        if(!this._fireOverlay) {
            return null;
        }

        return TweenLite.to(this._fireOverlay, duration, {
            alpha : 0, onComplete : () => {
                this._fireOverlay.stopLoop();
                this._fireOverlay.hide();
            }
        });
    }

    protected playFireSound?():void;

    protected abstract createFireOverlay():TimelineSprite;
}